import { render, staticRenderFns } from "./RemnantPastReview.vue?vue&type=template&id=3f59d1cc"
import script from "./RemnantPastReview.vue?vue&type=script&lang=js"
export * from "./RemnantPastReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports